// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"64":"editEvent","594":"inspiration"}[chunkId] + "." + {"64":"bea15d55d43cf087e63a","594":"b6f002ec4b6d93902ef3"}[chunkId] + ".bundle.js";
};